import { useEffect, useState } from 'react';
export var useToggleBackAfterDelay = function (input, resetMillis) {
    if (resetMillis === void 0) { resetMillis = 5000; }
    var _a = useState(false), inState = _a[0], setInState = _a[1];
    useEffect(function () {
        var timer;
        if (input) {
            setInState(true);
            timer = setTimeout(function () {
                setInState(false);
            }, resetMillis);
        }
        return function () {
            clearTimeout(timer);
        };
    }, [input]);
    return inState;
};
